import React, { useEffect, useState } from "react";
import DiscussionTickets from "../DiscussionTickets/DiscussionTickets";
import "./AllTickets.css";
import { MdSearch } from "react-icons/md";
import { getTickets } from "../../../../services/Tickets/ticket.service";
import { useSearchParams } from "react-router-dom";
import { convertTime } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

function AllTickets() {
  const { t } = useTranslation("tickets");
  const [tickets, setTickets] = useState([]);
  const [TicketDetails, getTicketDetails] = useState();
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [keyword, setKeyword] = useState("");
  const [ticketStats, setTicketStats] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [parentLoading, setParentLoading] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();

  const clearFilters = () => {
    searchParams.delete("ticket_no");
    setSearchParams(searchParams);
  };

  const handleTicketClick = (ticketId) => {
    setParentLoading(true);
    getTicketDetails(ticketId);
    setSelectedTicketId(ticketId);
  };

  const handleKeywordChange = (e) => {
    setKeyword(e?.target?.value);
    searchParams.delete("ticket_no");
    setSearchParams(searchParams);
  };

  const getTicketsList = async () => {
    setLoading(true);
    try {
      const response = await getTickets(
        currentPage,
        status,
        keyword,
        searchParams.get("ticket_no")
      );
      setTickets(response.data.result.tickets.data);
      setTotalPages(response.data.result.tickets.last_page);
      setTicketStats(response.data.result.tickets_stats);

      if (response?.data.result.tickets.data.length > 0) {
        handleTicketClick(response.data.result.tickets.data[0].id);
      } else {
        setParentLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setParentLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTicketsList();
  }, [currentPage, status, keyword, searchParams.get("ticket_no")]);

  return (
    <>
      <div className="allTickets__main_wrap">
        <div className="allTickets__main_tabs"></div>
        <div className="allTickets__main_list">
          <div className="allTickets__main_list_title">{t("list.title")}</div>
          <ul className="allTickets__status_filter">
            <li
              onClick={() => {
                setStatus("");
                searchParams.delete("ticket_no");
                setSearchParams(searchParams);
              }}
              className={`${status === "" ? "active" : ""}`}
            >
              {t("list.all")}{" "}
              <span className="count">
                {ticketStats?.All > 0 ? ticketStats?.All : 0}
              </span>
            </li>
            <li
              onClick={() => {
                setStatus("Open");
                searchParams.delete("ticket_no");
                setSearchParams(searchParams);
              }}
              className={`${status === "Open" ? "active" : ""}`}
            >
              {t("list.open")}{" "}
              <span className="count">
                {ticketStats?.Open > 0 ? ticketStats?.Open : 0}
              </span>
            </li>
            <li
              onClick={() => {
                setStatus("Resolved");
                searchParams.delete("ticket_no");
                setSearchParams(searchParams);
              }}
              className={`${status === "Resolved" ? "active" : ""}`}
            >
              {t("list.resolved")}{" "}
              <span className="count">
                {ticketStats?.Resolved > 0 ? ticketStats?.Resolved : 0}
              </span>
            </li>
            <li
              onClick={() => {
                setStatus("Disputed");
                searchParams.delete("ticket_no");
                setSearchParams(searchParams);
              }}
              className={`${status === "Disputed" ? "active" : ""}`}
            >
              {t("list.disputed")}{" "}
              <span className="count">
                {ticketStats?.Disputed > 0 ? ticketStats?.Disputed : 0}
              </span>
            </li>
          </ul>
          <div className="allTickets__main_list_search">
            <MdSearch />
            <input
              type="text"
              placeholder={t("common:actions.search")}
              value={keyword}
              onChange={handleKeywordChange}
            />
          </div>
          {searchParams.get("ticket_no") && (
            <div
              style={{
                marginBottom: "8px",
                textAlign: "center",
                color: "blue",
                fontSize: "15px",
              }}
            >
              {" "}
              {t("list.filterByNo", { no: searchParams.get("ticket_no") })}{" "}
              <span
                onClick={clearFilters}
                title={t("list.clearFilter")}
                style={{
                  color: "red",
                  paddingLeft: "3px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {" "}
                X
              </span>
            </div>
          )}
          <ul className="allTickets__main_list_wrapper">
            {loading &&
              Array.from({ length: 6 }).map((_, i) => (
                <li key={`skeleton-${i}`} className="allTickets__list_skeleton">
                  <div className="h-[26px] w-[26px] shrink-0 animate-pulse rounded-full bg-ui-border" />
                  <div className="flex w-full flex-col gap-1.5">
                    <div className="h-3 w-1/2 animate-pulse rounded bg-ui-border" />
                    <div className="h-2.5 w-3/4 animate-pulse rounded bg-ui-border" />
                    <div className="h-2.5 w-1/3 animate-pulse rounded bg-ui-border" />
                  </div>
                </li>
              ))}

            {!loading && tickets.length === 0 && (
              <li className="allTickets__list_empty">{t("list.empty")}</li>
            )}

            {!loading &&
              tickets.map((ticket, index) => (
              <li
                className={`allTickets__main_list_li ${
                  selectedTicketId === ticket.id ? "selected" : ""
                }`}
                key={ticket?.id}
                onClick={() => handleTicketClick(ticket?.id)}
              >
                <div className="allTickets__main_list_left_col">
                  <div className="allTickets__ticket_name">
                    <div className="allTickets__icon_counter">
                      {ticket?.user.firstname.charAt(0)}
                      {ticket?.user.lastname.charAt(0)}{" "}
                      <span>{ticket?.total_responses}</span>
                    </div>
                    <div className="allTickets__name_id">
                      <div className="allTickets__name_role">
                        <span className="allTickets__name">
                          {ticket?.user?.firstname}
                        </span>
                        <span className="allTickets__role">
                          {" "}
                          ({ticket?.user?.role})
                        </span>
                      </div>
                      <div className="allTickets__name_Ids">
                        <div className="allTickets__main_list_right_left">
                          <span className="title">
                            {t("list.ticketId")}{" "}
                            <span className="value"> {ticket?.ticket_no}</span>
                          </span>
                        </div>

                        <div className="allTickets__main_list_right_left">
                          <span className="title">
                            {t("list.shipmentId")}{" "}
                            <span className="value">
                              {" "}
                              {ticket?.shipment?.id}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="allTickets__ticket_description">
                    {ticket?.description.slice(0, 40)}
                  </div>
                  <div className="allTickets__ticket_status">
                    {/* {ticket?.reason && <div className="allTickets__ticket_item">
                      <div className="title">Reason</div>
                      <div className={`allTickets__ticket_item_tag ${ticket?.reason}`}>
                     { ticket?.reason}
                      </div>
                    </div>
                       } */}
                    {/* {ticket?.priority && <div className="allTickets__ticket_item">
                      <div className="title">priority</div>
                      <div className={`allTickets__ticket_item_tag ${ticket?.priority}`}>
                     { ticket?.priority}
                      </div>
                    </div>
                       } */}
                    {/* {ticket?.status && <div className="allTickets__ticket_item">
                      <div className="title">status</div>
                      <div className={`allTickets__ticket_item_tag ${ticket?.status}`}>
                     { ticket?.status}
                      </div>
                    </div>
                       } */}
                  </div>
                </div>

                <div className="allTickets__main_list_right_col">
                  <div className={ticket?.priority + " allTickets__date_time"}>
                    {convertTime(ticket?.updated_at)}
                  </div>
                  {/* <div className='allTickets__status'>{ticket?.status}</div> */}
                  <div className="allTickets__main_list_right_item_wrapper">
                    <div className="allTickets__main_list_right_title">
                      {t("list.tracking")}
                    </div>
                    <div className="allTickets__main_list_right_value">
                      {ticket?.shipment?.tracking_id}
                    </div>
                  </div>

                  <div className="allTickets__shipment_logo">
                    {ticket?.shipment?.shipping_company?.shipping_company
                      ?.logo_url && (
                      <img
                        src={
                          ticket?.shipment?.shipping_company?.shipping_company
                            ?.logo_url
                        }
                        alt="-"
                      />
                    )}
                  </div>
                  </div>
                </li>
              ))}
          </ul>
          <div className="pagination__forList_main_wrap">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              className={currentPage === 1 ? "disable__btn_arrow" : ""}
            >
              <div className="pagination__forList_main_Icon">{"<"}</div>
            </button>
            <span>
              {t("list.page", { page: currentPage, total: totalPages })}
            </span>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              className={currentPage === totalPages ? "disable__btn_arrow" : ""}
            >
              <div className="pagination__forList_main_Icon">{">"}</div>
            </button>
          </div>
        </div>
      </div>
      <div className="disussion_shipping_details_box">
        <DiscussionTickets
          ticketId={TicketDetails}
          parentLoading={parentLoading}
          setParentLoading={setParentLoading}
        />
      </div>
    </>
  );
}

export default AllTickets;
